import React, { useEffect, useState } from 'react';
import { useSelector, useStore } from 'react-redux';
import CloseIcon from '../../assets/svg/CloseIcon';
import Shoppingbag from '../../assets/svg/Shoppingbag';
import FreeShippingProgress from './ElementFreeShip.tsx';
import { RootState } from '../../../redux/checkoutredux/store/checkoutStore';

interface BlockHeaderProps {
  toggleSidebar: () => void;
}

const BlockHeader: React.FC<BlockHeaderProps> = ({ toggleSidebar }) => {
  const store = useSelector((state: RootState) => state);
  const reduxStore = useStore(); // Direktes Abonnement über den Redux-Store
  const [quantity, setQuantity] = useState<number>(
    Number(store.shoppingcart.metacartdata?.[0]?.quantityall || 0)
  );

  useEffect(() => {
    const updateQuantity = () => {
      const newQuantity = Number(store.shoppingcart.metacartdata?.[0]?.quantityall || 0);
      setQuantity(newQuantity);
    };

    // Abonnement über Redux-Store
    const unsubscribe = reduxStore.subscribe(updateQuantity);

    return () => {
      unsubscribe();
    };
  }, [reduxStore]);

  const handleCloseSidecart = () => {
    toggleSidebar();
  };

  return (
    <>
      <div className="row p-2 py-3 mx-0 ips-sidecart-elementheader">
        <div className="ips-sidecart-header">
          <div className="col-12 p-0">
            <div className="row p-0">
              <div className="col-4 p-0 d-flex align-items-center justify-content-start">
                <span className="ips-sidecart-close-btn" onClick={handleCloseSidecart}>
                  <CloseIcon />
                </span>
              </div>
              <div className="col-4 p-0">
                <div className="ips-sidecart-quantity-wrap">
                  <Shoppingbag />
                  <div className="ips-sidecart-quantity" style={{ opacity: 1 }}>
                    {quantity > 0 ? quantity : ''}
                  </div>
                </div>
              </div>
              <div className="col-4 p-0"></div>
            </div>
            {quantity > 0 && (
              <div className="row p-0">
                <FreeShippingProgress store={store} />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default BlockHeader;